// extracted by mini-css-extract-plugin
export default {"colHeading":"FarmerOrTraderHistory_colHeading__4whCb","colContent":"FarmerOrTraderHistory_colContent__xOzhR"};